// packages/ui/src/EntryCard.tsx
import { forwardRef } from 'react'
import { motion, MotionProps } from 'framer-motion'

export interface EntryCardProps extends MotionProps {
  title: string
  description: string
  link: string
  icon: React.ComponentType<{ className?: string }>
  cardClassName?: string
}

const EntryCard = forwardRef<HTMLAnchorElement, EntryCardProps>(
  ({ title, description, link, icon: Icon, cardClassName = '', ...motionProps }, ref) => (
    <motion.a
      href={link}
      ref={ref}
      className={`${cardClassName} group flex flex-col items-center text-center transition-all`}
      {...motionProps}
    >
      <div className="w-20 h-20 mb-4 flex items-center justify-center rounded-full bg-gradient-to-br from-teal-800 to-blue-800 group-hover:from-teal-600 group-hover:to-blue-600 transition-all">
        <Icon className="w-10 h-10 text-white group-hover:text-gray-200" />
      </div>
      <h3 className="text-2xl font-semibold text-white mb-2">{title}</h3>
      <p className="text-gray-300 mb-6">{description}</p>
    </motion.a>
  )
)

EntryCard.displayName = 'EntryCard'
export default EntryCard
